 

  <div #floatingWidget *ngIf="infoBars.length" class="floating-call-widget" [class.avoid-call-log-modal]="showCallLogModal" [attr.data-rekey]="infoBars.length" cdkDrag cdkDragLockAxis="x" [cdkDragDisabled]="showCallLogModal" (cdkDragStarted)="dragStarted()" (cdkDragMoved)="dragMoved()" (cdkDragEnded)="dragEnded($event)">
    <div  class="info-bars-wrapper" cdkDragHandle style="touch-action:none; cursor: grab; user-select: none;">
        <ng-container *ngFor="let bar of infoBars;  let i = index; trackBy: trackByCallId">
        <div class="info-bar-container" *ngIf="!(showCallLogModal && bar.data && bar.data.callId === selectedCallID)">

          <div *ngIf="bar.type === 'mini'" class="info-bar mini-bar1 count-bar">
            <div class="info-left" >
              <div class="text">
                <div class="name">{{ bar.count }} calls</div>
              </div>
            </div>
          </div>
          <div *ngIf="bar.type === 'full'" (click)="addNewRecords(bar.data)" [ngClass]="['info-bar', getBarColorClass(bar.data,infoBars) , bar.isClosing ? 'closing-bar' : '']">
         
            <div *ngIf="bar.data.state != 'ringing' && bar.data.customerId" class="drag-line" (click)="addNewRecords(bar.data)" style="width:20px; border:1px solid #FFF;"></div>
            
            <div class="info-left" (click)="addNewRecords(bar.data)">
              
                <div class="back-icon" >
                    <!-- Per-bar lookup (not a single shared countdown/showCountdown field) so
                         multiple bars can each run and display their own independent countdown. -->
                    <ng-container *ngIf="getCountdown(bar.data.callId) as barCountdown; else standardIcon">
                        <span class="countdown-text">{{ barCountdown }}</span>
                    </ng-container>
                    
                    <ng-template #standardIcon>
                        <!-- Connected outbound call: same outgoing icon as call-activity -->
                        <!-- <i *ngIf="bar.data.state === 'connected' && bar.data.direction === 'Outbound call' && bar.data.matchfound !== 1; else statusImage" -->
                        <i *ngIf="isOutboundCall(bar.data) && bar.data.state === 'connected' &&bar.data.matchfound !== 1; else statusImage"
                            class="fa-solid fa-phone-flip" style="font-size: 16px; color: #505B65;" aria-label="Outbound call"></i>
                        <ng-template #statusImage>
                            <img [src]="getDisplayIcon(bar.data)"
                                [class.ringing]="bar.data.state === 'ringing'"
                                alt="status">
                        </ng-template>
                    </ng-template>
                </div>
  
                <div class="text">
                    <!-- No customer match, in any state - show "Customer not found" as the name and
                         the number (once known) as the address, instead of the bare number as the
                         name. Still shows the loading shimmer while ringing with no number yet. -->
                    <ng-container *ngIf="!bar.data.customerId; else foundCustomerInfo">
                        <ng-container *ngIf="bar.data.contactnumber; else noNumberYet">
                            <div class="name">Customer not found</div>
                            <div class="address">{{ bar.data.contactnumber }}</div>
                        </ng-container>
                        <ng-template #noNumberYet>
                            <ng-container *ngIf="bar.data.state === 'ringing'; else customerNotFound">
                                <ng-template [ngTemplateOutlet]="showShimmer"></ng-template>
                            </ng-container>
                            <ng-template #customerNotFound>
                                <div class="name">Customer not found</div>
                            </ng-template>
                        </ng-template>
                    </ng-container>

                    <ng-template #foundCustomerInfo>
                        <div class="name">{{ bar.data.name || 'Unknown Number' }}</div>
                        <div class="address" *ngIf="bar.data.address">
                            {{ bar.data.address | slice:0:60 }}{{ bar.data.address?.length > 60 ? '...' : '' }}
                        </div>
                    </ng-template>
                </div>
            </div>
  
            <div class="info-right">
                <ng-container *ngIf="bar.data.customerId; else addCustomer">
                    <a class="view-link" (mousedown)="$event.stopPropagation()" (click)="goToView($event, bar.data)">View <img src="/images/Openlink.svg" alt="" class="imgarrow"></a>
                  </ng-container>
                
                <ng-template #addCustomer>
                    <a *ngIf="bar.data.state !== 'ringing'" class="view-link" (mousedown)="$event.stopPropagation()" (click)="goToAddNewCustomer($event, bar.data)">
                        Add new customer <img src="/images/Openlink.svg" alt="" class="imgarrow">
                    </a>
                </ng-template>
  
                <span class="close-icon" (click)="closeBar($event, bar.data.callId)">✕</span>
            </div>
          </div>

        </div>
        </ng-container>
      </div>
  </div>

<ng-container *ngIf="showCallLogModal">
  <app-cs-call-log-modal [activityList]="todayCallActivity" [showCallCustomFields]="true"
      [showCallNoteTemplateOption]="true" [showCallLogModal]="showCallLogModal" [customerId]="customerId"
      [editCallData]="callEditData" [usersList]="userList" [opportunityId]="opportunityId"
      [completedActivityData]="completeData" [screen]="modalType" [userInfo]="callUserInfo"
      [isNotificationPopup]="true" [dialPad]="true"
      (onClose)="onModalClose('call')" (onSave)="onCallLogSave($event)" (sendValue)="handleValue($event)">
  </app-cs-call-log-modal>
</ng-container>



<ng-template #showShimmer>
  <div class="shimmer-section">
      <div class="shimmer-line" style="width: 200px;"></div>
      <div class="shimmer-line" style="width: 300px"></div>
  </div>
</ng-template>
